<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { MYPAGE_ROUTE_NAMES } from '@/routers/constants';
import ItemList from '@/components/menu/common/item-list.vue';
import SectionWrapper from '@/components/menu/sections/section-wrapper.vue';

/**
 * 個人の設定は情報収集エージェントの設定（ANDEV-10190）とアカウント（ANDEV-10254）に、
 * ログアウトはヘッダーのユーザーメニュー（ANDEV-10189）に移したため、マイページの項目だけを出す。
 */

type ItemListProps = InstanceType<typeof ItemList>['$props'];
type ItemsProps = ItemListProps['items'];

const route = useRoute();

const myPageItems = computed<ItemsProps>(() => [
  {
    id: 'mypage',
    name: 'トップ',
    route: { name: MYPAGE_ROUTE_NAMES.profile },
    isSelected: [
      MYPAGE_ROUTE_NAMES.profile,
      MYPAGE_ROUTE_NAMES.marks,
      MYPAGE_ROUTE_NAMES.comments,
      MYPAGE_ROUTE_NAMES.views,
      MYPAGE_ROUTE_NAMES.myTags,
    ].some(v => v === route.name), // includesだとTypeErrorになるのでsomeで代用
    isSelectedExactRoute: true,
  },
  {
    id: 'export',
    name: 'エクスポート',
    route: {
      name: MYPAGE_ROUTE_NAMES.export,
    },
  },
]);
</script>
<template>
  <SectionWrapper>
    <ItemList title="マイページ" :items="myPageItems" />
  </SectionWrapper>
</template>
